import { Component, Element, h, Host, Prop, State } from '@stencil/core';

import { IUserInfo } from '../../../globals/MarketWebLoginManager';
import { state as headerState } from './pn-marketweb-siteheader-store';
import { LoginDialog, LoginDialogLink, ProfileSelectorCustomerItem, ProfileSelectorOrganization, SiteHeaderI18N } from './pn-marketweb-siteheader-types';
import { arrow_right } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-marketweb-siteheader-login-profileselection',
  styleUrl: 'pn-marketweb-siteheader-login-profileselection.scss',
})
export class PnMarketwebSiteheaderLoginProfileselection {
  @Element() hostElement: HTMLElement;

  // Login dialog
  @Prop({ mutable: true }) loginDialog: LoginDialog = null;
  @Prop() endpoint: string = '';
  @Prop() loggedin: boolean = false;
  @Prop() idNamespace: string = '';
  @Prop() heading: string = null;
  @Prop() i18n: SiteHeaderI18N = {
    searchlabel: '',
    searchplaceholder: '',
    searchbuttontext: '',
    menuHomeButton: '',
    menuGoBackButton: '',
    mainMenuButton: '',
    menuStartButton: '',
    profileSelectionFlyoutHeading: '',
  } as SiteHeaderI18N;

  @State() user: IUserInfo = null;

  @State() logoutLink: LoginDialogLink = null;
  @State() userName: string = null;
  @State() userEmail: string = '';

  @Prop({ mutable: true }) currentProfile: ProfileSelectorCustomerItem = null;
  @Prop({ mutable: true }) profileoptions: ProfileSelectorOrganization[] = [];

  componentWillLoad() {
    if (this.heading === null && this.i18n?.profileSelectionFlyoutHeading) {
      this.heading = this.i18n.profileSelectionFlyoutHeading;
    }
    this.init();
  }

  init() {
    this.updateUserInfo();
    this.adjustLoginLinks();
    this.fetchProfiles();
  }
  async fetchProfiles() {
    if (!this.loggedin || this.profileoptions.length > 0) {
      return;
    }
    let apiUrl = `${this.endpoint}${this.endpoint.lastIndexOf('/') > -1 && this.endpoint.lastIndexOf('/') === this.endpoint.length - 1 ? '' : '/'}api/user/parentorganizations`;
    const req = await fetch(apiUrl);
    const reqdata = await req.json();
    const fallbackData = {
      loggedin: true,
      organizations: [
        {
          name: 'Forsheda Livs AB',
          customerNumber: '5564513603',
          id: 'dbba867d-1dff-3dbb-b420-c57b4b828b73',
          selected: true,
          profiles: [
            {
              name: 'Forsheda Livs AB',
              customerNumber: '20685482',
              id: 'f757ba28-9a73-15a2-f128-4b394d970f3f',
              ssid: '',
              selected: false,
              customerGroup: 'Business',
            },
            {
              name: 'ICA MAXI KUNGSBACKA',
              customerNumber: '20831191',
              id: '5aea41df-32b0-3f7e-2946-78598360177d',
              ssid: '259686',
              selected: true,
              customerGroup: 'Agent',
            },
          ],
        },
        {
          name: 'Hem Livs i Kungsbacka AB',
          customerNumber: '5565271250',
          id: '97ca363c-40ef-cca9-7a3c-9e7f025567c2',
          selected: false,
          profiles: [
            {
              name: 'ICA KVANTUM KUNGSBACKA',
              customerNumber: '20831193',
              id: 'fbd61ffd-41c6-2206-b88e-cfef91e1dc39',
              ssid: '259691',
              selected: false,
              customerGroup: 'Agent',
            },
          ],
        },
        {
          name: 'ICA SUPERMARKET TORGET',
          customerNumber: '5568902679',
          id: '7cb76a94-e1a5-5f57-58fd-bc563851b28e',
          selected: false,
          profiles: [
            {
              name: 'ICA SUPERMARKET TORGET',
              customerNumber: '20831212',
              id: '3a2db017-b68f-6fa0-fe70-542c08cd97ce',
              ssid: '',
              selected: false,
              customerGroup: 'Agent',
            },
          ],
        },
      ],
    };
    const data = window.location.href.indexOf('localhost:6008') !== -1 ? fallbackData : reqdata;

    if (!data || !data.organizations || !data.organizations.length) {
      this.heading = ""; //this is to not get "logged in as" text when its private account
      return;
    }

    (data.organizations as ProfileSelectorOrganization[]).forEach(org => {
      if (org.selected === true && org.profiles) {
        const selectedProfile = org.profiles.filter(x => x.selected === true);
        if (selectedProfile && selectedProfile[0] && selectedProfile[0].customerGroup.toLocaleLowerCase() === 'agent' && selectedProfile[0].ssid) {
          org.customerNumber = selectedProfile[0].ssid;
        }
      } else {
        if (org.customerNumber.length === 10 && org.customerNumber.substring(0, 2) === '55') {
          org.customerNumber = org.customerNumber.substring(0, 6) + '-' + org.customerNumber.substring(6);
        }
        this.profileoptions.push(org);
      }
    });

    let currentProfileObj = data.organizations.filter(x => x.selected === true)[0];
    const userProfileOption = {
      name: this.userName,
      customerNumber: '',
      id: '',
      selected: !currentProfileObj,
      profiles: [],
    };
    if (!currentProfileObj) {
      currentProfileObj = userProfileOption;
    }

    if (currentProfileObj && currentProfileObj.name) {
      this.currentProfile = currentProfileObj;
    }
    this.profileoptions.push(userProfileOption);
  }
  adjustLoginLinks() {
    const adjustLink = (link, i) => {
      if (!link.isLogoutLink) {
        link.isLogoutLink = link.pageLink.indexOf('location.href') !== -1 && link.pageLink.indexOf('logout') !== -1;
      }
      if (link.isLogoutLink) {
        link.href = headerState.loginManager.getLogoutUrl(link.href);
      }

      if (i === 0 && !link.href) {
        link.href = headerState.loginManager.getLoginUrl();
        link.linkType = 'primary';
      }
      if (link.primaryLinkApperance && !link.linkType) {
        link.linkType = 'primary';
      }
    };

    if (this.loginDialog?.loggedInLinks) {
      this.loginDialog?.loggedInLinks.forEach(adjustLink);
    }

    this.logoutLink = this.loginDialog?.loggedInLinks.filter(x => x.isLogoutLink)[0] ?? null;
  }
  updateUserInfo() {
    const userInfo: IUserInfo = headerState.loginManager.getUserInfo();
    this.user = userInfo;
    if (!userInfo) {
      return;
    }
    if (userInfo && userInfo.email) {
      this.userEmail = userInfo.email;
    }
    if (userInfo && userInfo.given_name) {
      this.userName = userInfo.given_name + (userInfo?.family_name ? ` ${userInfo?.family_name}` : '');
    }
    if (userInfo && userInfo.given_name) {
      this.userName = userInfo.given_name;
      return;
    }
    if (userInfo && userInfo.family_name) {
      this.userName = userInfo.family_name;
      return;
    }
    if (userInfo && userInfo.username) {
      this.userName = userInfo.username;
      return;
    }
  }

  filterLogoutLink(loggedInLinks: LoginDialogLink[]): LoginDialogLink[] {
    return loggedInLinks.filter((link: LoginDialogLink) => !link.isLogoutLink);
  }

  render() {
    if (!this.loginDialog) {
      return;
    }

    let hostElementAttribute = {};
    return (
      <Host {...hostElementAttribute}>
        {this.heading ? <strong class="pn-marketweb-siteheader-login-profileselection-heading">{this.heading}</strong> : null}
        {this.currentProfile !== null && this.currentProfile.name ? (
          <div class="pn-marketweb-siteheader-login-profileselection-currentprofile">
            <div class="pn-marketweb-siteheader-login-profileselection-currentprofile-name">{this.currentProfile.name}</div>
            <div class="pn-marketweb-siteheader-login-profileselection-currentprofile-description">
              {this.currentProfile.customerNumber ? this.currentProfile.customerNumber : this.userEmail}
            </div>
          </div>
        ) : null}

        <pn-marketweb-siteheader-login-linklist
          links={this.filterLogoutLink(this.loginDialog.loggedInLinks)}
          idNamespace={this.idNamespace}
        ></pn-marketweb-siteheader-login-linklist>

        <div class="pn-marketweb-siteheader-login-profileselection-divider"></div>
        {this.profileoptions
          .filter(x => x.selected !== true)
          .map(organization => {
            let customerNumber = organization.profiles.length > 0 ? organization.profiles[0].customerNumber : organization.customerNumber;
            return (
              <div class="pn-marketweb-siteheader-login-profileselection-profileoption">
                {/* /api/user/setprofile? profile=xxxxx */}
                <a
                  href={`${this.endpoint}/api/user/setprofile?customernumber=${customerNumber}&returnUrl=${encodeURIComponent(window.location.href)}`}
                  class="pn-marketweb-siteheader-login-profileselection-profileoption-link"
                >
                  <div class="pn-marketweb-siteheader-login-profileselection-profileoption-content">
                    <div class="pn-marketweb-siteheader-login-profileselection-profileoption-name">{organization.name}</div>
                    <div class="pn-marketweb-siteheader-login-profileselection-profileoption-description">
                      {organization.customerNumber ? organization.customerNumber : this.userEmail}
                    </div>
                  </div>
                  <pn-icon icon={arrow_right} small="false" color="blue700"></pn-icon>
                </a>
              </div>
            );
          })}

        {this.logoutLink ? (
          <div class="pn-marketweb-siteheader-login-profileselection-logout">
            {/* https://se-inte.postnord.com/UnifiedLogin/ExternalLoginCallback?returnUrl=https://se-inte.postnord.com/handla-online&profile=770e785b-702b-dc22-b1e9-4839eded4f83 */}
            <a
              href={this.logoutLink.href}
              rel="nofollower noopener"
              id="pn-marketweb-header-logoutlink"
              onClick={() => headerState.loginManager.clearUserData()}
              class="pn-marketweb-siteheader-login-profileselection-logout-link"
            >
              {this.logoutLink.linkText}
            </a>
          </div>
        ) : null}
      </Host>
    );
  }
}
